export default __webpack_public_path__ + "static/media/ham-and-cheese.0b35309a.png";